export const LOAD_SALES = 'counter/LOAD_SALES';
export const LOAD_SALES_SUCCESS = 'counter/LOAD_SALES_SUCCESS';
export const LOAD_SALES_ERROR = 'counter/LOAD_SALES_ERROR';
export const LOAD_CREDITS = 'counter/LOAD_CREDITS';
export const LOAD_CREDITS_SUCCESS = 'counter/LOAD_CREDITS_SUCCESS';
export const LOAD_CREDITS_ERROR = 'counter/LOAD_CREDITS_ERROR';
export const LOAD_DUE_COLLECTIONS = 'counter/LOAD_DUE_COLLECTIONS';
export const SAVE_SALE_REQUEST = 'counter/SAVE_SALE_REQUEST';
export const SETTLE_CREDIT_REQUEST = 'counter/SETTLE_CREDIT_REQUEST';
export const CANCEL_SALE_REQUEST = 'counter/CANCEL_SALE_REQUEST';
